<div [class.invalid]="invalid" class="time-interval-selector">
  <div class="btn">
    <span class="material-icons">timelapse</span>
    <span class="label" i18n>Timeframe</span>
  </div>

  <div class="btn time-input-container">
    <span class="material-icons start-time-icon">keyboard_capslock</span>
    <input
      required
      type="time"
      (ngModelChange)="selectStartTime($event)"
      [ngModel]="startTime.format(timeFormat)"
    />
  </div>

  <div class="btn time-input-container">
    <span class="material-icons">last_page</span>
    <input
      type="time"
      required
      (ngModelChange)="selectEndTime($event)"
      [ngModel]="endTime.format(timeFormat)"
    />
  </div>
</div>